<template>
    <div class="sorting">
        <div class="sorting__container container container_xl">
            <select class="select" v-model="catId">
                <option :value="0">Latest</option>
                <option v-for="cat in categories" :value="cat.Id">{{cat.Name}}</option>
            </select>
            <select class="select" v-model="typeId">
                <option :value="0">All Types</option>
                <option v-for="t in types" :value="t.Id">{{t.Name}}</option>
            </select>
            <div class="sorting__search">
                <button class="sorting__result">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17.001" height="17" viewBox="0 0 17 17"><path d="M16.772 14.535l-4.352-4.352a6.626 6.626 0 0 0 1-3.474 6.769 6.769 0 1 0-3.234 5.713l4.352 4.35a.8.8 0 0 0 1.118 0l1.118-1.118a.8.8 0 0 0-.002-1.119zM6.709 11.181a4.472 4.472 0 1 1 4.472-4.472 4.473 4.473 0 0 1-4.472 4.472z" fill="#009dbb" /></svg>
                </button>
                <input class="sorting__input" type="text" name="query" v-model="query" placeholder="Search" @keydown.enter="emitChange">
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
        },
        data() {
            return {
                categories: [],
                types: [],
                catId: 0,
                typeId: 0,
                query: '',
            }
        },
        methods: {
            setCategory(catId) {
                this.catId = catId
            },
            emitChange() {
                var vm = this
                this.$emit('changed', { query: vm.query, catId: vm.catId, typeId: vm.typeId })
            }
        },
        watch: {
            catId() {
                this.emitChange()
            },
            typeId() {
                this.emitChange()
            }
        },
        mounted() {
            var vm = this
            vm.doPost('/umbraco/surface/article/getcategories', null, (data) => {
                vm.categories = data
            })
            vm.doPost('/umbraco/surface/article/gettypes', null, (data) => {
                vm.types = data
            })
            if (vm.querystringObject.catid) vm.catId = parseInt(vm.querystringObject.catid)
            if (vm.querystringObject.typeid) vm.typeId = parseInt(vm.querystringObject.typeid)
            if (vm.querystringObject.query) vm.query = vm.querystringObject.query
            if (vm.catId > 0 || vm.query != '') this.emitChange()
        }
    }
</script>